/**
 * Shared blocking rules (JS). Same logic for Web, Android VPN sync, and future iOS NE.
 * No network I/O. Does not log URLs.
 */

import {
  normalizeCategoryRules,
  parseBlockListText,
  parseKeywordList,
  normalizeBlockList,
  isUrlBlocked,
} from "../utils/websiteBlockerCore";
import { getCategoryModelForNative } from "./categoryModel";

export { parseBlockListText, parseKeywordList, normalizeBlockList, isUrlBlocked, normalizeCategoryRules };

/**
 * Canonical JSON for native DNS/VPN layers (Android VpnRulesStore, future iOS extension).
 * @param {{ block: string[], allow: string[], keywords: string[], categoryRules?: Record<string, "allow"|"block"|"ignore">, safeMode?: boolean }} rules
 */
export function serializeRulesForNative(rules) {
  return JSON.stringify({
    block: rules.block || [],
    allow: rules.allow || [],
    keywords: (rules.keywords || []).map((k) => String(k).toLowerCase()),
    categoryRules: normalizeCategoryRules(rules.categoryRules),
    categoryModel: getCategoryModelForNative(),
    // Default ON: Google SafeSearch + YouTube Restricted Mode via DNS VIP.
    safeMode: rules.safeMode !== false,
  });
}

/**
 * @param {string} blockedSitesText
 * @param {string} allowedSitesText
 * @param {string} blockedKeywordsText
 */
export function rulesFromSettingsText(blockedSitesText, allowedSitesText, blockedKeywordsText) {
  return {
    block: parseBlockListText(blockedSitesText),
    allow: parseBlockListText(allowedSitesText),
    keywords: parseKeywordList(blockedKeywordsText),
  };
}
